import { cn } from '@/lib/utils';

/** Shared classes for icon-only controls in the top navigation (uniform color & hover). */
export const navIconButtonClass = cn(
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-muted transition-colors',
  'hover:bg-card-hover hover:text-foreground',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
  ''
);
